import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';
import { hero } from '@/state/tour';
import { cut } from './swipe';

const noRaycast = () => null;

// A faint sheet along the cut, so the wipe reads as a line through the building.
export function CutSheet() {
  const ref = useRef<THREE.Mesh>(null);
  useFrame(() => {
    const mesh = ref.current;
    if (!mesh) return;
    mesh.visible = cut.active;
    if (!cut.active) return;
    const [x, y, z] = hero.position;
    mesh.position.set(cut.point.x - x, cut.point.y - y, cut.point.z - z);
    mesh.rotation.set(0, Math.atan2(cut.normal.x, cut.normal.z), 0);
    mesh.scale.set(cut.width, cut.height, 1);
  });
  return (
    <mesh ref={ref} visible={false} raycast={noRaycast}>
      <planeGeometry args={[1, 1]} />
      <meshBasicMaterial
        color="#4cc9f0"
        transparent
        opacity={0.06}
        side={THREE.DoubleSide}
        depthWrite={false}
      />
      <lineSegments>
        <edgesGeometry args={[new THREE.PlaneGeometry(1, 1)]} />
        <lineBasicMaterial color="#4cc9f0" />
      </lineSegments>
    </mesh>
  );
}
